import React from "react";
import { Paper, Typography, Box, Skeleton } from "@mui/material";
import {
  TrendingUp,
  AccessTime,
  CheckCircle,
  Warning,
} from "@mui/icons-material";

const SummaryCard = ({ icon, title, amount, color, loading, showNegative }) => {
  return (
    <Paper
      sx={{
        p: 2,
        display: "flex",
        alignItems: "center",
        gap: 2,
        borderRadius: 2,
        border: `1px solid ${color}20`,
      }}
    >
      <Box
        sx={{
          bgcolor: `${color}20`,
          p: 1.5,
          borderRadius: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {icon}
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography variant="body2" color="text.secondary" fontSize="0.85rem">
          {title}
        </Typography>
        {loading ? (
          <Skeleton width={100} height={32} />
        ) : (
          <Typography variant="h6" fontWeight={600} fontSize="1.1rem">
            {showNegative && amount > 0 ? "-" : ""}₹{Math.abs(amount).toFixed(2)}
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

const TransactionsSummaryCards = ({ data, loading }) => {
  const cards = [
    {
      icon: <TrendingUp sx={{ color: "#2196f3" }} />,
      title: "Total Earnings",
      amount: data.totalEarnings,
      color: "#2196f3",
    },
    {
      icon: <AccessTime sx={{ color: "#ff9800" }} />,
      title: "Pending Amount",
      amount: data.totalPending,
      color: "#ff9800",
    },
    {
      icon: <CheckCircle sx={{ color: "#4caf50" }} />,
      title: "Received Amount",
      amount: data.totalPaid,
      color: "#4caf50",
    },
    {
      icon: <Warning sx={{ color: "#f44336" }} />,
      title: "Total Penalties",
      amount: data.totalPenalties,
      color: "#f44336",
      showNegative: true,
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
      }}
    >
      {cards.map((card, index) => (
        <Box
          key={index}
          sx={{
            flex: { xs: "1 1 calc(50% - 8px)", md: "1 1 calc(25% - 12px)" },
          }}
        >
          <SummaryCard {...card} loading={loading} />
        </Box>
      ))}
    </Box>
  );
};

export default TransactionsSummaryCards;
